import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import './assets/scss/index.scss'
import './assets/scss/app.css'
import { persistor, store } from './redux/store'
import App from './App'
import reportWebVitals from './reportWebVitals'
import ErrorBoundary from './shared/ErrorBoundary'
import ErrorBoundaryAlert from './shared/ErrorBoundaryAlert'
import ToasterComponent from './helpers/Toaster'

// import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <ErrorBoundary fallback={ErrorBoundaryAlert}>
    <Suspense fallback={null}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
      <ToasterComponent />
    </Suspense>
  </ErrorBoundary>
)

reportWebVitals()
